import { render, staticRenderFns } from "./SVGLabel.vue?vue&type=template&id=a9825f66&scoped=true&"
import script from "./SVGLabel.vue?vue&type=script&lang=js&"
export * from "./SVGLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9825f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9825f66')) {
      api.createRecord('a9825f66', component.options)
    } else {
      api.reload('a9825f66', component.options)
    }
    module.hot.accept("./SVGLabel.vue?vue&type=template&id=a9825f66&scoped=true&", function () {
      api.rerender('a9825f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGLabel.vue"
export default component.exports